import { render, staticRenderFns } from "./switch_account_form.vue?vue&type=template&id=c5d233d8&"
import script from "./switch_account_form.vue?vue&type=script&lang=js&"
export * from "./switch_account_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports